module.exports = JBrowseExports["@jbrowse/core/util/types/mst"];